import { ApiService } from '../../services/api.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CALENDAR_LOCALE } from '../../services/constant';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
var ImportDataComponent = (function () {
    function ImportDataComponent(apiService, authService, modelService, translate, modalService) {
        this.apiService = apiService;
        this.authService = authService;
        this.modelService = modelService;
        this.translate = translate;
        this.modalService = modalService;
        this.itemsPerPage = 40;
        this.startDate = null;
        this.endDate = null;
        this.totalItems = 0;
        this.currentPage = 1;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.tableCol = [];
        this.loading = false;
        this.sentdata = null;
        this.tableData = [];
        this.disable = false;
        this.downloading = false;
    }
    ImportDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.loadTexts();
        this.loadData();
    };
    ImportDataComponent.prototype.loadTexts = function () {
        var _this = this;
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.statusData = [
            { label: this.translate.instant('COMMON.ALL'), value: null },
            { label: this.translate.instant('TEXT.SUCCESS'), value: 'success' },
            { label: this.translate.instant('TEXT.FAILED'), value: 'failed' }
        ];
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            _this.tableCol.push({ field: 'created_at', header: _this.translate.instant('TABLE.IMPORT-DATE') }, { field: 'invoice_number', header: _this.translate.instant('FILTER.INVOICE-NUMBER') }, { field: 'status', header: _this.translate.instant('IMPORT-DATA.STATUS') });
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
        });
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.defaultStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.defaultEndDate = moment(this.endDate).format('DD/MM/YYYY');
    };
    ImportDataComponent.prototype.resolveError = function ($event, popup, data) {
        this.modalData = data;
        this.disable = false;
        this.modal = this.modalService.open(popup, { backdrop: 'static', keyboard: false, centered: true });
    };
    ImportDataComponent.prototype.revertBack = function () {
        this.modal.close();
    };
    Object.defineProperty(ImportDataComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportDataComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    ImportDataComponent.prototype.pageChanged = function () {
        this.sentdata = 1;
        this.loadData(this.currentPage);
    };
    ImportDataComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    ImportDataComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    ImportDataComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    ImportDataComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = '';
        }
        else {
            this.sortMode = '-';
        }
    };
    ImportDataComponent.prototype.clearSearch = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.documentNumber = null;
        this.selectedStatus = null;
        this.endDate = new Date();
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = null;
        this.disable = false;
        this.modal = null;
        this.loadTexts();
        this.loadData();
    };
    ImportDataComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.loadData();
    };
    ImportDataComponent.prototype.loadData = function (page) {
        var _this = this;
        this.clickedStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.clickedEndDate = moment(this.endDate).format('DD/MM/YYYY');
        this.tableData = [];
        var sniffTargetArr = [];
        var params = new HttpParams();
        params = params.append('header_issue_date_start', moment(this.startDate).format('YYYY-MM-DD'));
        params = params.append('header_issue_date_end', moment(this.endDate).format('YYYY-MM-DD'));
        if (this.sortBy) {
            params = params.append('ordering', this.sortMode + this.sortBy);
        }
        if (this.sentdata) {
            params = params.append('page', this.currentPage.toString());
            params = params.append('page_size', this.itemsPerPage.toString());
        }
        if (this.selectedStatus) {
            params = params.append('status', this.selectedStatus);
            sniffTargetArr.push('IMPORT-DATA.STATUS-TYPE');
        }
        if (this.defaultStartDate !== this.clickedStartDate || this.defaultEndDate !== this.clickedEndDate) {
            sniffTargetArr.push('TABLE.IMPORT-DATE');
        }
        if (this.documentNumber) {
            params = params.append('invoice_number', this.documentNumber);
            sniffTargetArr.push('FILTER.INVOICE-NUMBER');
        }
        this.loading = true;
        this.apiService.getErrors(params).subscribe(function (data) {
            _.forEach(data.results, function (obj) {
                _this.tableData.push({
                    'created_at': obj.created_at,
                    'status': obj.status,
                    'invoice_number': obj.invoice_number,
                    'detail': obj.detail.message,
                    'row': obj.detail.row ? obj.detail.row : '-'
                });
            });
            if (data) {
                _this.totalItems = data.count;
            }
            _this.loading = false;
        });
        if (page == null) {
            var sniffTarget = sniffTargetArr.join(', ');
            this.sniff('SEARCH', sniffTarget);
        }
    };
    ImportDataComponent.prototype.downloadImportDataReport = function () {
        var _this = this;
        var params = new HttpParams();
        params = params.append('header_issue_date_start', moment(this.startDate).format('YYYY-MM-DD'));
        params = params.append('header_issue_date_end', moment(this.endDate).format('YYYY-MM-DD'));
        this.downloading = true;
        this.apiService.downloadImportDataReport(params).subscribe(function (data) {
            _this.downloading = false;
            var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = 'import_data_report.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, function (err) {
            _this.downloading = false;
            console.log(err.error);
        });
        this.sniff('DOWNLOAD_XLS', 'import_data_report.xlsx');
    };
    ImportDataComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'IMPORT_DATA',
            target: target
        };
        this.apiService.sniff(data).subscribe();
    };
    ImportDataComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return ImportDataComponent;
}());
export { ImportDataComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/import-data/import-data.component.ts.pre-build-optimizer.js